import React from 'react'
import { formatWithComma } from '@/lib/number'
import { colors } from 'plume-ui'
import { css } from '@emotion/react'
import { IGNORED_BY_WOVN_CLASS_NAME } from '@/lib/wovn'

type Props = {
  children?: number | null
  sub?: string
  unit?: string
  className?: string
}

export const FormattedNumber: React.FC<Props> = (props) => {
  if (props.children === null || props.children === undefined) {
    return null
  }

  return (
    <span>
      <span className={props.className}>
        <span className={IGNORED_BY_WOVN_CLASS_NAME}>
          {formatWithComma(props.children)}
        </span>
        <span
          css={css`
            margin-left: 4px;
          `}
        >
          {props.unit}
        </span>
      </span>
      {props.sub && (
        <div
          css={css`
            color: ${colors.textLight};
            font-size: 12px;
            line-height: 1.5;
          `}
        >
          {props.sub}
        </div>
      )}
    </span>
  )
}
